// extracted by mini-css-extract-plugin
module.exports = {"collapse_body":"collapsibleContainer_collapse_body__3BJlK"};